import { defaultState } from "@/shared/utilities/constants";

export default () => ({
  usersEvaluation: { ...defaultState },
});